import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { ItemStatusEnum } from '@/modules/common';
import {
  PageHeader,
  Spinner,
  useApiMutation,
  useApiQuery,
} from '@/modules/common';
import { Routes } from '@/router/routes';

import { MasksTable } from '../components';
import { Mask } from '../types';

export const MasksPage: FC = () => {
  const navigate = useNavigate();

  const { isFetching, data, refetch } = useApiQuery<Mask[]>('/masks', {
    queryKey: ['masks'],
    initialData: [],
  });

  const updateMaskMutation = useApiMutation<Mask>(
    '/masks',
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  const toggleMaskStatus = async (style: Mask) => {
    await updateMaskMutation.mutateAsync({
      ...style,
      status:
        style.status === ItemStatusEnum.Archived
          ? ItemStatusEnum.Ready
          : ItemStatusEnum.Archived,
    });
    return await refetch();
  };

  const redirectToStyleDetails = (item) => {
    navigate(Routes.MaskDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Masks"
        actions={[
          <Link
            to={Routes.NewMask}
            key="new-mask"
            data-testid="add-new-mask-link"
          >
            <Button disabled={isFetching} data-testid="add-new-mask-button">
              <PlusSquareIcon />
              Add new mask
            </Button>
          </Link>,
        ]}
      />

      {isFetching ? (
        <Spinner />
      ) : (
        <MasksTable
          data={data}
          toggleStatus={toggleMaskStatus}
          onClick={redirectToStyleDetails}
        />
      )}
    </div>
  );
};
